import { TContactSales } from './ContactSales';

import { richTextWithPlaceholder } from 'utils/prismic';

export const useContactSalesData = (data: TContactSales) => {
  if (!('slice_type' in data)) return null;
  const { primary, items } = data;

  const { contact_sales_is_dark: isDark, contact_sales_has_top_padding: hasTopPadding } = primary;

  const tabs = items.map(
    ({
      contact_sales_tab_title: title,
      contact_sales_tab_content: content,
      contact_sales_tab_link: link,
      contact_sales_tab_link_label: linkLabel,
    }) => ({
      title: richTextWithPlaceholder(title, ''),
      content: richTextWithPlaceholder(content, ''),
      link: link?.url ?? '/',
      linkLabel: linkLabel ?? 'Contact sales',
    })
  );

  return {
    isDark,
    hasTopPadding,
    tabs,
  };
};
